<template>
  <div v-if="isiframe">
  </div>
  <div v-else-if="isMobile">
    <v-app-bar flat color="transparent">
      <v-toolbar-title class="pr-5">IDM2021 - Buffon's Needle Challenge</v-toolbar-title>
    </v-app-bar>
    <v-container>
    <About />
    </v-container>
  </div>
  <div v-else>
    <v-app-bar flat color="transparent">
      <v-toolbar-title class="pr-5">IDM2021 - Buffon's Needle Challenge</v-toolbar-title>
      <v-spacer></v-spacer>
      <About />
    </v-app-bar>
  </div> 
</template>
<script>
import About from '@/components/AboutGlobal.vue'
export default {
  components: {
    About
  },
  computed: {
    isiframe(){
      if ( window.location !== window.parent.location ) 
      { 
        return true 
      } else{
        return false
      }
    },
    isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
      
  }
}
</script>